import { React } from "react";
import { useTranslation } from 'react-i18next';

const Cabecera = ({ lang, tipo }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <section className="section-top">
            <div className="container">
                <div className="text-center col-lg-10 offset-lg-1">
                    <div className="section-top-title">
                        <img src={"/images/web/werespect/" + tipo + ".png"} alt={tipo} style={{ width: "300px" }} />
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Cabecera;

